import React, { useMemo, memo } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import { CUSTOM_MESSAGES } from '@veriables';
import Modal from '@components/common/Modal';
import { TouchableButton } from '@components/common/Touchable';

const OfferModal = ({ isOpen = false, handleOfferModalClose = () => {}, serverAppTheme }) => {
  const ConfirmationPopUpStyle = useMemo(() => {
    const optionsPopUp = {
      backgroundColor: serverAppTheme?.popUp_bg,
      borderRadius: '16px',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
      margin: 'auto',
      minHeight: '216px',
      padding: '1.5rem',
      position: 'relative',
    };
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    return { okButton, optionsPopUp };
  }, [serverAppTheme]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOfferModalClose}
      style={ConfirmationPopUpStyle.optionsPopUp}
      customClass="h-100 w-100"
      customClass2="h-100 w-100 my-0"
    >
      <div className="text-center p-4">
        <div className="mb-4">
          <h4 style={{ color: serverAppTheme?.primary_text }}>
            {CUSTOM_MESSAGES().OLS_OFFER_ALREADY_APPLIED}
          </h4>
        </div>
        <TouchableButton
          className={cn('col-6 btn44 btn-ripple fs_24 fw-600')}
          onClick={e => {
            e.preventDefault();
            handleOfferModalClose();
          }}
          style={ConfirmationPopUpStyle.okButton}
          rippleEffect={true}
        >
          OK
        </TouchableButton>
      </div>
    </Modal>
  );
};

const mapStateToProps = ({ theme }) => ({
  serverAppTheme: theme.serverAppTheme,
});

const MemoizedOfferModal = memo(OfferModal);

export default connect(mapStateToProps)(MemoizedOfferModal);
